import {
  BarChart3,
  Clapperboard,
  FileText,
  Link2,
  LogOut,
  Menu,
  Package,
  PlugZap,
  ReceiptText,
  RotateCcw,
  ShoppingBag,
  Settings2,
  Store,
  X,
} from "lucide-react";
import { useState, type ReactNode } from "react";
import { Button } from "./UI";

export type AppRoute =
  | "dashboard"
  | "produtos"
  | "pauta"
  | "conteudos"
  | "links"
  | "vendas"
  | "plataformas"
  | "conexoes"
  | "vitrine";

const nav: Array<{ route: AppRoute; label: string; icon: typeof BarChart3 }> = [
  { route: "dashboard", label: "Visão geral", icon: BarChart3 },
  { route: "produtos", label: "Produtos", icon: Package },
  { route: "pauta", label: "Pauta do TikTok", icon: Clapperboard },
  { route: "conteudos", label: "Conteúdos", icon: FileText },
  { route: "links", label: "Links", icon: Link2 },
  { route: "vendas", label: "Vendas", icon: ReceiptText },
  { route: "plataformas", label: "Plataformas", icon: Settings2 },
  { route: "conexoes", label: "Conexões", icon: PlugZap },
  { route: "vitrine", label: "Minha vitrine", icon: Store },
];

export function Shell({
  route,
  navigate,
  children,
  isDemo,
  saving,
  onReset,
  onSignOut,
}: {
  route: AppRoute;
  navigate: (route: AppRoute) => void;
  children: ReactNode;
  isDemo: boolean;
  saving: boolean;
  onReset: () => void;
  onSignOut: () => void;
}) {
  const [open, setOpen] = useState(false);
  const go = (next: AppRoute) => {
    navigate(next);
    setOpen(false);
  };
  return (
    <div className="app-shell">
      <a className="skip-link" href="#main">
        Pular para o conteúdo
      </a>
      <aside
        className={`sidebar ${open ? "sidebar--open" : ""}`}
        aria-label="Navegação principal"
      >
        <div className="brand-lockup">
          <span className="brand-mark">
            <ShoppingBag size={23} aria-hidden="true" />
          </span>
          <div>
            <strong>WeSell</strong>
            <small>afiliados com clareza</small>
          </div>
          <button
            className="icon-button sidebar__close"
            onClick={() => setOpen(false)}
            aria-label="Fechar menu"
          >
            <X size={20} />
          </button>
        </div>
        <nav aria-label="Navegação principal">
          {nav.map(({ route: itemRoute, label, icon: Icon }) => (
            <button
              key={itemRoute}
              className={
                route === itemRoute ? "nav-item nav-item--active" : "nav-item"
              }
              onClick={() => go(itemRoute)}
              aria-current={route === itemRoute ? "page" : undefined}
            >
              <Icon size={19} aria-hidden="true" />
              <span>{label}</span>
            </button>
          ))}
        </nav>
        <div className="sidebar__footer">
          {isDemo ? (
            <Button variant="ghost" onClick={onReset}>
              <RotateCcw size={17} /> Restaurar exemplos
            </Button>
          ) : null}
          <button className="nav-item" onClick={onSignOut}>
            <LogOut size={19} />
            <span>{isDemo ? "Sair da demonstração" : "Sair"}</span>
          </button>
        </div>
      </aside>
      {open ? (
        <button
          className="sidebar-scrim"
          onClick={() => setOpen(false)}
          aria-label="Fechar menu"
        />
      ) : null}
      <div className="app-column">
        <header className="topbar">
          <button
            className="icon-button mobile-menu"
            onClick={() => setOpen(true)}
            aria-label="Abrir menu"
          >
            <Menu size={22} />
          </button>
          <div className="topbar__status">
            <span className={saving ? "pulse-dot" : "status-dot"} />
            {saving
              ? "Salvando…"
              : isDemo
                ? "Modo demonstração"
                : "Dados protegidos"}
          </div>
          <button
            className="avatar"
            onClick={() => go("vitrine")}
            aria-label="Abrir configurações da vitrine"
          >
            LM
          </button>
        </header>
        <main id="main" className="main-content">
          {children}
        </main>
      </div>
    </div>
  );
}
